
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaigns/math-topics",
      function () {
        return require("private-next-pages/campaigns/math-topics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaigns/math-topics"])
      });
    }
  